import { LabelledDocumentDetails } from '@containers/form-i9/document-details-list/labelled-document-details';
import { ThinSeparator } from '@containers/form-i9/document-details-list/styles';
import { getDocumentDetailsListTranslations } from '@containers/form-i9/document-details-list/translations';
import {
    BorderedGrid,
    BorderedGridItem
} from '@containers/form-i9/styles';
import { ISection2DocumentDetails } from '@models/onboarding-review/section2-document-details';
import { Section2ValidationErrors } from '@models/onboarding-review/section2-validation-errors';
import { Title } from '@screens/review-section3/review/styles';
import { ISection2DocumentsStore } from '@stores/onboarding-review/section2-documents-store';
import { VerticalLayout } from '@styles/spacing-styles';
import { ISection2DocumentTypesValidation } from '@stores/onboarding-review/section2-document-types-validation-store';
import { observer } from 'mobx-react';
import * as React from 'react';

interface IProps {
    store: ISection2DocumentsStore;
    renderAdditionalInformation: ((listForm: string) => React.ReactNode) | React.ReactNode;
    qrCodeSection: React.ReactNode;
    validationErrors: Record<Section2ValidationErrors, boolean>;
}

const renderProvidedDocuments = (
    title: React.ReactNode,
    documents: ISection2DocumentDetails[],
    options: {
        allDocumentTypes: string[];
        documentTitlePlaceholder: string;
        detailKey: string;
        validationErrors: Record<Section2ValidationErrors, boolean>;
    },
    documentTypesValidation: ISection2DocumentTypesValidation[]
) => {
    if (documents.length === 0) {
        return null;
    }

    return (
        <React.Fragment>
            {title}
            {
                documents.map((document, index) => (
                    <LabelledDocumentDetails details={document}
                                             validationErrors={options.validationErrors}
                                             detailsKey={`${options.detailKey}-${index}`}
                                             key={document.documentType}
                                             allDocumentTypes={options.allDocumentTypes}
                                             documentTitlePlaceholder={options.documentTitlePlaceholder}
                                             documentTypesValidation={documentTypesValidation}
                                             />
                ))
            }
        </React.Fragment>
    );
};

const CollapsedDocumentDetailsList: React.FunctionComponent<IProps> = observer(props => {
    const {
        store,
        renderAdditionalInformation,
        qrCodeSection,
        validationErrors
    } = props;

    const translations = getDocumentDetailsListTranslations();

    const allDocumentTypes = store.allDocuments.map(({ documentType }) => documentType);

    return (
        <VerticalLayout innerSpacing='medium'>
            {/* Only show provided documents */}
            {
                renderProvidedDocuments(
                    <Title align='center'>
                        <p>{translations.listA}</p>
                        <p>{translations.listAHeading}</p>
                    </Title>,
                    store.listA,
                    {
                        allDocumentTypes,
                        validationErrors,
                        detailKey: 'collapsed-list-a',
                        documentTitlePlaceholder: translations.listADocumentTypePlaceholder
                    },
                    store.documentTypesValidationsAll
                )
            }
            {
                renderProvidedDocuments(
                    <Title align='center'>
                        <p>{translations.listB}</p>
                        <p>{translations.listBHeading}</p>
                    </Title>,
                    store.listB,
                    {
                        allDocumentTypes,
                        validationErrors,
                        detailKey: 'collapsed-list-b',
                        documentTitlePlaceholder: translations.listBDocumentTypePlaceholder
                    },
                    store.documentTypesValidationsAll
                )
            }
            {
                renderProvidedDocuments(
                    <Title align='center'>
                        <p>{translations.listC}</p>
                        <p>{translations.listCHeading}</p>
                    </Title>,
                    store.listC,
                    {
                        allDocumentTypes,
                        validationErrors,
                        detailKey: 'collapsed-list-c',
                        documentTitlePlaceholder: translations.listCDocumentTypePlaceholder
                    },
                    store.documentTypesValidationsAll
                )
            }
            <ThinSeparator />
            <BorderedGrid container={true}>
                <BorderedGridItem xs={12}>
                    {
                        typeof renderAdditionalInformation === 'function' ?
                            renderAdditionalInformation('collapsed') :
                            renderAdditionalInformation
                    }
                </BorderedGridItem>
                <BorderedGridItem xs={12}>
                    {qrCodeSection}
                </BorderedGridItem>
            </BorderedGrid>
        </VerticalLayout>
    );
});

export default CollapsedDocumentDetailsList;



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/collapsed.tsx